// frontend/src/pages/ForgotPassword.jsx
import React, { useState } from 'react';
import axios from 'axios';
import './Auth.css';
import './AuthArtDirection.css';
import fullLogo from '../assets/branding/abogados_quiroz_logo_exact.svg';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    setError(null);

    try {
      const response = await axios.post(`${window.__CRM_API__ || 'http://localhost:8000/api'}/auth/forgot-password`, { email });
      setMessage(response.data.email_configured === false
        ? 'El correo saliente aún no está configurado. Un administrador debe completar SMTP o Gmail en Configuración.'
        : response.data.mensaje);
      setEmail('');
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al enviar la solicitud');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container"><div className="auth-shell">
      <aside className="auth-brand-panel"><img src={fullLogo} alt="Abogados Quiroz" /><div><p className="auth-eyebrow">LEGAL OPERATIONS WORKSPACE</p><h1>Abogados Quiroz</h1><p>Protegemos su acceso y la información sensible de la firma.</p><blockquote>“Tu historia es nuestro motor; tus sueños, nuestro compromiso.”</blockquote></div></aside>
      <div className="auth-card">
        <div className="auth-header">
          <p className="auth-eyebrow">ACCESO SEGURO</p><h1>Recuperar contraseña</h1>
          <p>Te enviaremos un enlace seguro para restablecer tu contraseña.</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {message && (
            <div className="auth-success">
              <span>✅</span> {message}
            </div>
          )}
          {error && (
            <div className="auth-error">
              <span>⚠️</span> {error}
            </div>
          )}

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@quirozlawfirm.com"
              required
            />
          </div>

          <button type="submit" className="btn-auth" disabled={loading}>
            {loading ? 'Enviando...' : 'Enviar enlace de recuperación'}
          </button>

          <p className="auth-link">
            <a href="/login">← Volver al inicio de sesión</a>
          </p>
        </form>
      </div></div></div>
  );
};

export default ForgotPassword;
